import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import Introduction004 from './Introduction004'
import Introduction005 from './Introduction005'
import Introduction006 from './Introduction006'
import Introduction007 from './Introduction007'
import Introduction008 from './Introduction008'
import Introduction009 from './Introduction009'
import Introduction010 from './Introduction010'
import Introduction011 from './Introduction011'
import Introduction012 from './Introduction012'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 30px;

  .p-txt-date {
    margin-top: -10px;
    color: #ababab;
  }

  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 16px;
    color: #505050;
    line-height: 1.6em;

    h1 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #f5f5f5;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-bottom: 30px;
      margin-top: 10px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #77d7c9;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h2 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #ffffff;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-top: 10px;
      margin-bottom: 30px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #d8d8d8;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h3 {
      color: #414141;
      font-size: 16px;
      line-height: 1.4em;
      background: #ffffff;
      width: auto;
      padding: 10px 0 8px;
      margin-top: -10px;
      margin-bottom: 20px;
      border-top: solid 2px #e5e5e5;
      border-bottom: solid 2px #e5e5e5;
    }

    p {
      padding-bottom: 30px;
      line-height: 2;
      position: relative;

      span {
        background: linear-gradient(transparent 60%, #ff6 60%);
        font-weight: 600;
      }

      .p-list-link {
        position: absolute;
        top: 6px;
        right: 2px;

        &:before {
          display: block;
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          top: 7px;
          left: -14px;
          border-left: 8px solid #3ec7b3;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
        }
      }

      &.txt-color-red {
        color: #ff6969;
      }
    }

    .link-div {
      width: 100%;
      display: flex;
      justify-content: left;
      padding-bottom: 30px;

      > div {
        width: 50px;
      }

      .link-p {
        width: calc(100% - 50px);

        .p-list-link {
          position: absolute;
          top: -3px;
          left: 30px;

          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 11px;
            left: -14px;
            border-left: 8px solid #3ec7b3;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
          }
        }
      }
    }

    img {
      width: 100%;
      height: auto;
      padding-bottom: 30px;
    }
  }

  ${BreakPoints.large} {
  }
`
type Props = {
  /** 広告の番号 */
  no: number
}

/**
 * コラム記事詳細：記事本体
 * @constructor
 */
const ColumnDetailInner0084 = (props: Props): JSX.Element => (
  <Wrapper>
    <ColumnH1 label="産後パパ育休制度の概要とその意義" />
    {/** TODO 川上申し送り事項：▼投稿日をここに表示 */}
    <p className="p-txt-date">2025.09.18</p>
    <section>
      {/** TODO 川上申し送り事項：▼記事投稿（？）で作成された内容がここに入る予定 */}
      <p>
        我が国は出生数が年々減少しており、2022年はついに
        <span>
          出生数が80万人を下回り、引き続き少子高齢化社会が継続することが鮮明
        </span>
        となりました。少子高齢化社会の一要因としては共働き社会への移行や男性の育児参加率の低さも示唆されており、2022年10月には育児介護休業法の改正により「産後パパ育休」が創設されました。今回は産後パパ育休制度についての主な内容から活用することが期待される制度的な側面を解説します。
      </p>
      <img src="/images/column/details/c0084.jpg" alt="キンクラコラム画像84" />
      <div id="toc1">
        <h1>これまでの制度からの変更点</h1>
      </div>
      <p>
        法改正前であってもパパ休暇という制度があり、産後8週間以内の男性育休のことを指していました。法改正前の育児休業は1度取得し、復帰すると再度の取得はできませんでしたが、パパ休暇を取得した場合は再度の育児休業の取得が可能でした。この点は法改正後も変更がないだけでなく、更に「拡充」している点があります。
        <br />
        <br />
        まず、育児休業中は本来、就労という想定がありません。そもそも「休業」とは、「休暇」と異なり一定期間以上の就労の免除が想定されており、育児休業と仕事を並行するという考え方は両立しません。しかし、
        <span>
          男性の育児休業取得率は女性と比べて著しく低く、かつ、足枷となっている部分として、仕事を休むことへのためらいや同僚へのしわ寄せを気にするとの声が少なくありませんでした。
        </span>
        そこで、労使協議によって、定められた範囲内において、育児休業をしながら育児休業の途中で出社することも可能となりました。
        <br />
        <br />
        法改正前であっても通常の育児休業中は臨時的かつ一時的な就労であれば可能とされていましたが、
        <span>
          産後パパ育休の大きな特徴として、臨時的かつ一時的ですらなく育児休業の途中で就労が可能となっている点
        </span>
        です。
      </p>

      <div id="toc2">
        <h1>産休・育休の違い</h1>
      </div>
      <p>
        似て非なるものとして、産休と育休があります。まず、
        <span>産休は生物学的に女性のみが取ることができる休業</span>
        です。なぜなら子供を産むことができるのは女性のみであり、負担の大きい産前産後の期間中の就労を免除する制度です。他方、
        <span>育休については性別不問で取得できる制度</span>
        です。
      </p>

      {/** ここに9パターンの広告設定する */}
      {props.no === 0 && <Introduction004 />}
      {props.no === 1 && <Introduction005 />}
      {props.no === 2 && <Introduction006 />}
      {props.no === 3 && <Introduction007 />}
      {props.no === 4 && <Introduction008 />}
      {props.no === 5 && <Introduction009 />}
      {props.no === 6 && <Introduction010 />}
      {props.no === 7 && <Introduction011 />}
      {props.no === 8 && <Introduction012 />}

      <div id="toc3">
        <h1>産後パパ育休の詳細</h1>
      </div>
      <p>
        産後パパ育休についてはあくまで産後8週間以内に「4週間（28日）を限度」として「2回に分けて」取得できる休業です。また、1歳までの育児休業とは別に取得できる制度です。すなわち、将来的に再度の育児休業を取得できる権利も残っているため、
        <span>
          男性としても申し出がしやすく、男性の育児休業取得促進に繋げるための制度
        </span>
        と言えます。また、子の出生直後の時期（子の出生後8週間以内）は母子ともに安静にしておくべき期間であり、父として活躍が望まれる期間でもあります。このような状況下で柔軟に育児休業を取得できることで、家族の絆を深められることや、安心して第2子以降の出産に望める土壌が整うとの指摘もあります。繰り返しになりますが、産後パパ育休は分割して2回の取得が可能です。これは産後8週間以内に1度取得し、再度産後パパ育休を取得できるだけでなく、更に通常育休も取得できるため、
        <span>1歳までの間に最大で4回の育児休業を取得できる</span>
        ということになります。
        <br />
        <br />
        もちろん、産後パパ育休期間中であっても、通常育休と同様に
        <span>社会保険加入者については社会保険料の免除制度があります。</span>
        法律上は通常の育児休業期間中および産後パパ育休期間中は
        <span>
          給料の支払い義務がないため、一部の大企業等を除き、我が国の99%を占める中小企業では無給となるケースが一般的
        </span>
        です。そのような状況下では社会保険料が給与天引きできないとの問題点が浮上しますが、
        <span>
          月末時点で育児休業を取得しているケースと、同じ月内で14日以上育児休業を取得している場合は給与に係る社会保険料は免除
        </span>
        されます。
      </p>

      <div id="toc4">
        <h1>産後パパ育休のメリット・デメリットについて</h1>
      </div>
      <p>
        産後パパ育休のメリットについては、産後パパ育休中においても例外的ですらなく
        <span>育休中に仕事ができる点</span>
        があげられます。他方、デメリットについてはあくまで産後8週間以内に「4週間（28日）を限度」として取得できる制度ですので、
        <span>通常育休と比べると期間が限定的</span>
        となる点です。
      </p>

      <div id="toc5">
        <h1>給付金制度について</h1>
      </div>
      <p>
        産後パパ育休中についても
        <span>
          一定期間以上の雇用保険加入者であれば育児休業給付金の支給対象
        </span>
        となります。もちろん途中で欠勤等が多く、支給要件を満たさないというケースもあり得ますが、育児休業を開始した日前2年間において、給与の支払基礎日数が11日以上ある（ない場合は就業した時間数が80時間以上の）月が12か月以上あることが要件とされています。
      </p>

      <div id="toc6">
        <h1>最後に</h1>
      </div>
      <p>
        育児介護休業法は2022年に大きな改正が行われ、改正内容の目玉が産後パパ育休の創設です。産後パパ育休は期間が限定されているものの、その理由として、産後8週間は女性でいう「強制的な就労禁止期間」にあたる産後休業期間にあたります。よって、同期間に男性が育児休業を取得することで母体の安全確保や、そのような状況下で育児参加をすることで仕事だけでは得られることのできない貴重な経験を積むことが可能となります。
      </p>
    </section>
  </Wrapper>
)

export default ColumnDetailInner0084
